import React, { useState, useEffect } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import EditGtinPrefixForm from '../components/EditGtinPrefixForm';

const EditGtinPrefixPage = () => {
  const { id } = useParams<{ id: string }>();
  const history = useHistory();
  const [initialData, setInitialData] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!id) return;
      
      try {
        const response = await fetch(`/api/admin/autotreat_mfr/gtin_prefixes/${id}/`, {
          headers: {
            'Authorization': `Bearer ${sessionStorage.getItem('accessToken')}`
          }
        });
        
        if (!response.ok) {
          throw new Error('Failed to fetch GTIN prefix data');
        }
        
        const data = await response.json();
        setInitialData(data);
      } catch (err) {
        setError(err instanceof Error ? err.message : 'An error occurred');
        console.error('Error fetching GTIN prefix:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [id]);

  const handleSuccess = () => {
    history.push('/admin/manufacturer_management?activeTab=4');
  };

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;
  if (!initialData) return <div>No data found</div>;

  return <EditGtinPrefixForm id={id!} initialData={initialData} onSuccess={handleSuccess} />;
};

export default EditGtinPrefixPage;